<div class="profile">
  <div class="profile__head">
    <button
      (click)="openModalChangePassword()"
      class="btn btn-accent-filter icon">
      <img src="assets/img/key.svg" alt="icon" class="icon-button">
      {{'PROFILE_PAGE.CHANGE_PASSWORD' | translate}}
    </button>
    <button
      *ngIf="userData?.two_factor_auth"
      (click)="change2FA(false)"
      class="btn btn-light-filter icon">
      <img src="assets/img/block.svg" alt="icon" class="icon-button">
      {{'PROFILE_PAGE.OFF_2FACTOR' | translate}}
    </button>
    <button
      *ngIf="!userData?.two_factor_auth"
      (click)="change2FA(true)"
      class="btn btn-light-filter icon">
      <img src="assets/img/on-2factor.svg" alt="icon" class="icon-button">
      {{'PROFILE_PAGE.ON_2FACTOR' | translate}}
    </button>
  </div>
  <div class="profile__block">
    <div class="profile__block-left">
      <div class="avatar">
        <span class="avatar__name">{{fistLetter}}</span>
        <span
          *ngIf="true"
          class="avatar__state unlocked">
          {{'PROFILE_PAGE.UNLOCKED' | translate}}
        </span>
        <span
          *ngIf="false"
          class="avatar__state blocked">
          {{'PROFILE_PAGE.BLOCKED' | translate}}
        </span>
      </div>
      <div class="date">
        <p class="date__name">{{'PROFILE_PAGE.DATE' | translate}}</p>
        <p class="date__value">{{userData?.date}}</p>
      </div>
    </div>
    <div class="profile__block-right">
      <button
        *ngIf="!isEdit"
        (click)="isEdit = !isEdit"
        class="edit-btn">
        <img src="assets/img/edit-icon.svg" alt="Edit" class="edit-btn__icon">
      </button>

      <form
        [formGroup]="form"
        (ngSubmit)="sendForm()" class="form">
        <div class="form__line">
          <div
            [class.active]="isEdit"
            [class.error]="form.get('fullNameFormControl')?.invalid && form.get('fullNameFormControl')?.touched"
            class="input-block fullName">
            <input
              formControlName="fullNameFormControl"
              id="fullName"
              [readonly]="!isEdit"
              class="input"
              type="text"
              placeholder=" ">
            <label
              for="fullName"
              class="placeholder">
              {{'PROFILE_PAGE.FULL_NAME' | translate}}
            </label>
            <ng-container *ngIf="form.get('fullNameFormControl')?.invalid && form.get('fullNameFormControl')?.touched">
              <span
                *ngIf="fullNameRequiredError"
                class="input-block__error">
                {{'PROFILE_PAGE.FULL_NAME_REQUIRED' | translate}}
              </span>
              <span
                *ngIf="fullNameFormatError && !fullNameRequiredError"
                class="input-block__error">
                {{'PROFILE_PAGE.FULL_NAME_FORMAT_ERROR' | translate}}
              </span>
            </ng-container>
          </div>
        </div>
        <div class="form__line">
          <div
            [class.active]="isEdit"
            [class.error]="form.get('phoneFormControl')?.invalid && form.get('phoneFormControl')?.touched"
            class="input-block">
            <input
              formControlName="phoneFormControl"
              [readonly]="!isEdit"
              id="phone"
              prefix="+7 "
              mask="000 000 00 00"
              class="input"
              type="text"
              placeholder=" ">
            <label
              for="phone"
              class="placeholder">
              {{'PROFILE_PAGE.PHONE' | translate}}
            </label>
            <ng-container *ngIf="form.get('phoneFormControl')?.invalid && form.get('phoneFormControl')?.touched">
              <span
                *ngIf="phoneRequiredError"
                class="input-block__error">
                {{'PROFILE_PAGE.PHONE_REQUIRED' | translate}}
              </span>
              <span
                *ngIf="phoneFormatError"
                class="input-block__error">
                {{'PROFILE_PAGE.PHONE_FORMAT_ERROR' | translate}}
              </span>
            </ng-container>
          </div>
        </div>
        <div class="form__line">
          <div
            class="input-block role">
            <input
              formControlName="roleFormControl"
              id="role"
              readonly
              class="input"
              type="text"
              placeholder=" ">
            <label
              for="role"
              class="placeholder">
              {{'PROFILE_PAGE.ROLE' | translate}}
            </label>
          </div>
          <div
            class="input-block phone">
            <input
              formControlName="emailFormControl"
              id="email"
              readonly
              class="input"
              type="text"
              placeholder=" ">
            <label
              for="email"
              class="placeholder">
              {{'PROFILE_PAGE.EMAIL' | translate}}
            </label>
          </div>
        </div>
        <div
          *ngIf="isEdit"
          class="btn-block">
          <button
            [disabled]="form.invalid"
            type="submit"
            class="btn btn-accent">
            {{'PROFILE_PAGE.SAVE' | translate}}
          </button>
          <button
            (click)="quitEdit()"
            type="button"
            class="btn btn-light">
            {{'PROFILE_PAGE.CANCEL' | translate}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>


<app-modal
  [(isOpenModal)]="isOpenModalChangePassword">
  <app-change-password-dialog
    (changePassword)="changePassword()">
  </app-change-password-dialog>
</app-modal>
